// let apiBaseUrl = 'https://backendrodeo.insiderodeo.com/api/v1/';
// let socketUrl = 'https://backendrodeo.insiderodeo.com:6672';
let apiBaseUrl = "https://backendrodeo.glohtesting.com/api/v1/";
let socketUrl = "https://backendrodeo.glohtesting.com:6682";
let cloudFrontUrl = "";
let pfrApiUrl = "";

let appStage = process.env.REACT_APP_STAGE;

if (appStage == "dev") {
  // apiBaseUrl = 'https://backendrodeo.insiderodeo.com/api/v1/';
  // socketUrl = 'https://backendrodeo.insiderodeo.com:6672';
  // apiBaseUrl = "https://backendrodeo.glohtesting.com/api/v1/";
  apiBaseUrl = "https://irbackend.dreamztesting.com/api/v1/";
  // apiBaseUrl = "http://10.25.27.57:8002/api/v1/";
  // socketUrl = 'https://irsocketstage.dreamztesting.com:6672/';
  socketUrl = "https://socket.insiderodeo.com:6670/";
  cloudFrontUrl = "https://d22z93bum7xzz9.cloudfront.net/assets/share_image/";
  pfrApiUrl = "https://pfr-backend.glohtesting.com/api/v1/";
} else if (appStage == "uat") {
  apiBaseUrl = "https://backendrodeo.insiderodeo.com/api/v1/";
  socketUrl = "https://backendrodeo.insiderodeo.com:6672";
} else if (appStage == "prod") {
  apiBaseUrl = "https://backendrodeo.insiderodeo.com/api/v1/";
  socketUrl = "https://socket.insiderodeo.com:6672/";
  // apiBaseUrl = 'https://backendrodeo.glohtesting.com/api/v1/';
  // socketUrl = 'https://backendrodeo.glohtesting.com:6682';
  cloudFrontUrl = "https://d2mkr7tc1e0pje.cloudfront.net/assets/share_image/";
  pfrApiUrl = "https://controlcenter.profantasyrodeo.com/api/v1/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const CLOUDFRONT_URL = cloudFrontUrl;
export const PFR_API_URL = pfrApiUrl;
